services.service('SocialAuthService', [
    '$q', 'config', 'ExternalScriptLoader', 'GoogleAuthProvider', 'FacebookAuthProvider',

    function ($q, config, ExternalScriptLoader, GoogleAuthProvider, FacebookAuthProvider) {
        var providers = new Map();
        var self = this;

        this.init = function () {
            createProviderConfig()
                .forEach(function (item) {
                    var provider = initializeProvider(item);
                    provider.init()
                        .then(function () {
                            providers.set(item.provider, provider)
                        })
                        .catch(function (error) {
                            console.warn("Auth provider [" + item.provider + "] initialization error", error)
                        })
                })
        }


        this.signInWithGoogle = function () {
            var provider = providers.get("google");
            if (!provider) {
                throw new Error("Auth provider [google] is not registered!")
            }

            return provider.signIn()
        }

        this.signInWithFacebook = function () {
            var provider = providers.get("facebook");
            if (!provider) {
                throw new Error("Auth provider [facebook] is not registered!")
            }

            return provider.signIn()
        }


        this.signOut = function () {
            return $q
                .all(
                    Array.from(providers.keys())
                        .map(function (item) {
                            return providers.get(item).signOut(true)
                        }))
                .catch(function (error) {
                    console.warn(error)
                })
        }

        this.isProviderReady = function (provider) {
            var _provider = providers.get(provider)
            return _provider && _provider.ready;
        }


        function createProviderConfig() {
            var _config = []
            if (config["googleProviderId"]) {
                _config.push({provider: "google", id: config["googleProviderId"]})
            }
            if (config["facebookProviderId"]) {
                _config.push({provider: "facebook", id: config["facebookProviderId"]})
            }
            return _config
        }

        function initializeProvider(_config) {
            switch (_config.provider) {
                case "google":
                    return new GoogleAuthProvider(_config)
                case "facebook":
                    return new FacebookAuthProvider(_config)
                default:
                    throw new Error("Auth provider [" + _config.provider + "] is not implemented!")
            }
        }

        return this;

    }])
